class LoyaltyPoints extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.loadingEl = this.querySelector('[data-loyalty-points-loading]');
    this.successEl = this.querySelector('[data-loyalty-points-success]');
    this.failEl = this.querySelector('[data-loyalty-points-fail]');
    this.failMessageEl = this.querySelector('[data-loyalty-points-fail-message]');
    this.errorEl = this.querySelector('[data-loyalty-points-error]');
    this.imageEl = this.querySelector('[data-loyalty-points-image]');
    this.downloadEl = this.querySelector('[data-loyalty-points-download]');
    this.numberEl = this.querySelector('[data-loyalty-points-number]');
    this.pointsEl = this.querySelector('[data-loyalty-points-points]');
    this.createForm = this.querySelector('[data-loyalty-points-create]');
    this.emailInput = this.querySelector('[data-loyalty-points-email-input]');
    this.appleWalletBtn = this.querySelector('[data-loyalty-points-apple-wallet]');
    this.googleWalletBtn = this.querySelector('[data-loyalty-points-google-wallet]');

    const urlEmail = new URLSearchParams(window.location.search).get('email');
    const isLoggedIn = this.dataset.customerLoggedIn === 'true';
    const customerEmail = this.dataset.customerEmail || '';

    this.email = urlEmail || customerEmail || '';
    this.loyaltyCardBarcode = null;
    this.customerName =
      [this.dataset.customerFirstName, this.dataset.customerLastName].filter(Boolean).join(' ') ||
      'Име Фамилия';

    this.API_BASE = 'https://apps.gloross.com/Alchemista';
    this.REQUEST_TIMEOUT_MS = 20000;
    this.CREATE_INTRO = 'Попълнете данните по-долу, за да създадете Alchemista Club Card.';
    this.NOT_FOUND_INTRO =
      'Не беше открита Alchemista Club Card с този имейл адрес. Желаете ли да създадете карта?';

    if (!this.email || !isLoggedIn) {
      this.showCreateForm(this.CREATE_INTRO);
    } else {
      if (this.emailInput) this.emailInput.value = this.email;
      this.loadCard(this.email);
    }

    this.createForm?.addEventListener('submit', (e) => this.onCreateSubmit(e));
    this.googleWalletBtn?.addEventListener('click', (e) => this.onGoogleWalletClick(e));
    this.appleWalletBtn?.addEventListener('click', (e) => this.onAppleWalletClick(e));
  }

  setVisible(el, visible) {
    if (!el) return;
    el.classList.toggle('is-visible', visible);
  }

  showLoading(visible) {
    this.setVisible(this.loadingEl, visible);
  }

  hideAllStates() {
    this.setVisible(this.successEl, false);
    this.setVisible(this.failEl, false);
    this.setVisible(this.errorEl, false);
  }

  formatPoints(points) {
    try {
      if (
        typeof themeVendor !== 'undefined' &&
        themeVendor.themeCurrency &&
        typeof themeVendor.themeCurrency.formatMoney === 'function' &&
        typeof theme !== 'undefined' &&
        theme.moneyFormat
      ) {
        return points + ` (${themeVendor.themeCurrency.formatMoney(points / 0.3909304, theme.moneyFormat)})`;
      }
    } catch (error) {
      console.error('Error formatting points:', error);
    }
    return String(points ?? '');
  }

  populateSuccess(data) {
    this.loyaltyCardBarcode = data.cardNumber;
    if (this.imageEl && data.imageBase64) {
      this.imageEl.setAttribute('src', `data:image/png;base64,${data.imageBase64}`);
    }
    if (this.downloadEl) {
      if (data.imageBase64) this.downloadEl.setAttribute('href', `data:image/png;base64,${data.imageBase64}`);
      this.downloadEl.hidden = !data.imageBase64;
    }
    if (this.numberEl) this.numberEl.textContent = data.cardNumber || '';
    if (this.pointsEl) this.pointsEl.textContent = this.formatPoints(data.points);

    this.hideAllStates();
    this.setVisible(this.successEl, true);
  }

  showError(message) {
    this.hideAllStates();
    if (this.errorEl && message) {
      const errorText = this.errorEl.querySelector('p');
      if (errorText) errorText.textContent = message;
    }
    this.setVisible(this.errorEl, true);
  }

  showCreateForm(message) {
    this.hideAllStates();
    if (this.failMessageEl) this.failMessageEl.textContent = message;
    if (this.email && this.emailInput && !this.emailInput.value) {
      this.emailInput.value = this.email;
    }
    this.setVisible(this.failEl, true);
  }

  decodeMaybeHex(value) {
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!/^[0-9a-fA-F]+$/.test(trimmed) || trimmed.length % 2 !== 0) return value;
    try {
      const decoded = trimmed
        .match(/.{1,2}/g)
        .map((byte) => String.fromCharCode(parseInt(byte, 16)))
        .join('');
      return decoded || value;
    } catch (error) {
      return value;
    }
  }

  async parseResponse(response) {
    const text = await response.text();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (error) {
      return this.decodeMaybeHex(text);
    }
  }

  buildCreateUrl(email, phone, name) {
    // Do not use URLSearchParams — it encodes "+" as "%2B", which the API rejects.
    // Do not send "location" — any non-empty value makes CreatePromoCard hang
    // indefinitely (see the #issue-loyalty-card flow in custom.js).
    return `${this.API_BASE}/CreatePromoCard?email=${encodeURIComponent(email)}&phone=${phone}&name=${encodeURIComponent(
      name,
    )}`;
  }

  buildGetUrl(email, phone) {
    return `${this.API_BASE}/GetPromoCard?email=${encodeURIComponent(email)}&phone=${phone || ''}`;
  }

  // The API can hang instead of answering, which would leave the spinner
  // running forever. Always bound the request.
  postWithTimeout(url) {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) {
      options.signal = AbortSignal.timeout(this.REQUEST_TIMEOUT_MS);
    }

    return fetch(url, options);
  }

  fetchPromoCard(email, phone) {
    return this.postWithTimeout(this.buildGetUrl(email, phone)).then((response) => this.parseResponse(response));
  }

  handleCardData(data) {
    if (!data || typeof data !== 'object') {
      this.showError('Възникна грешка при получаване на информация за картата. Моля, опитайте отново по-късно.');
      return;
    }

    if (data.result == false) {
      this.showCreateForm(this.NOT_FOUND_INTRO);
      return;
    }

    this.populateSuccess(data);
  }

  loadCard(emailToLoad) {
    this.showLoading(true);
    this.hideAllStates();

    this.fetchPromoCard(emailToLoad)
      .then((data) => {
        this.handleCardData(data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.showError('Възникна грешка при получаване на информация за картата. Моля, опитайте отново по-късно.');
      })
      .finally(() => {
        this.showLoading(false);
      });
  }

  async onCreateSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const submitBtn = this.createForm.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(this.createForm);
    const phone = String(formData.get('phone') || '')
      .trim()
      .replace(/[\s\-]/g, '');
    const firstName = String(formData.get('first_name') || '').trim();
    const lastName = String(formData.get('last_name') || '').trim();
    const formEmail = String(formData.get('email') || this.email || '').trim();
    this.customerName = `${firstName} ${lastName}`.trim() || 'Име Фамилия';

    if (!formEmail) {
      this.showCreateForm(this.CREATE_INTRO);
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    if (!phone) {
      this.showError('Моля, въведете валиден телефонен номер.');
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    this.email = formEmail;
    this.showLoading(true);
    this.hideAllStates();

    try {
      const createResponse = await this.postWithTimeout(this.buildCreateUrl(formEmail, phone, this.customerName));

      const createData = await this.parseResponse(createResponse);

      // The API reports its own failures as HTTP 200 with result:false,
      // so the status code alone is not enough.
      if (!createResponse.ok || !createData || createData.result != true) {
        const message =
          typeof createData === 'string'
            ? createData
            : createData?.error ||
              createData?.message ||
              'Възникна грешка при създаване на картата. Моля, опитайте отново по-късно.';
        throw new Error(this.decodeMaybeHex(String(message)));
      }

      // The card is not queryable for a couple of seconds after creation —
      // retry GetPromoCard to get the image and points.
      let cardData = null;
      for (let attempt = 0; attempt < 3; attempt++) {
        if (attempt > 0) await new Promise((resolve) => setTimeout(resolve, 1500));
        try {
          cardData = await this.fetchPromoCard(formEmail, phone);
        } catch (error) {
          cardData = null;
        }
        if (cardData && typeof cardData === 'object' && cardData.result != false) break;
        cardData = null;
      }

      // The card exists at this point (CreatePromoCard returns its number in
      // "data"), so never send the user back to the create form.
      this.populateSuccess(cardData || {cardNumber: createData.data, points: 0});
    } catch (error) {
      console.error('Error:', error);

      const timedOut = error?.name === 'TimeoutError' || error?.name === 'AbortError';
      this.showError(
        timedOut
          ? 'Услугата не отговори навреме. Моля, опитайте отново.'
          : error?.message || 'Възникна грешка при създаване на картата. Моля, опитайте отново по-късно.',
      );
      // Keep the form available so the user can retry.
      this.setVisible(this.failEl, true);
      if (submitBtn) submitBtn.disabled = false;
    } finally {
      this.showLoading(false);
    }
  }

  onGoogleWalletClick(e) {
    e.preventDefault();

    if (!this.loyaltyCardBarcode) {
      console.error('loyaltyCardBarcode is not defined');
      return;
    }

    fetch(
      `${this.API_BASE}/GetGoogleWalletCardUrl?barcode=${encodeURIComponent(
        this.loyaltyCardBarcode,
      )}&customerName=${encodeURIComponent(this.customerName)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
      .then((response) => this.parseResponse(response))
      .then((data) => {
        if (data?.redirectUrl) {
          window.open(data.redirectUrl, '_blank');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  onAppleWalletClick(e) {
    e.preventDefault();

    if (!this.loyaltyCardBarcode) {
      console.error('loyaltyCardBarcode is not defined');
      return;
    }

    fetch(
      `${this.API_BASE}/GetAppleWalletCard?barcode=${encodeURIComponent(
        this.loyaltyCardBarcode,
      )}&customerName=${encodeURIComponent(this.customerName)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
      .then((response) => this.parseResponse(response))
      .then((data) => {
        if (!data?.success) {
          console.error('Failed to download file');
          return;
        }

        const {data: fileData, fileName, contentType} = data;
        const byteCharacters = atob(fileData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: contentType});
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

if (!customElements.get('loyalty-points')) {
  customElements.define('loyalty-points', LoyaltyPoints);
}
